// extracted by mini-css-extract-plugin
module.exports = {"legal":"SignUp-module--legal--19GO8","secondaryAction":"SignUp-module--secondaryAction--1CsgM","prompt":"SignUp-module--prompt--3fGbY"};